import { SubmitFeedback } from '@/app/pages/feedback/submit-feedback';
import { createFileRoute } from '@tanstack/react-router';

import { bookingIdSearchSchema } from '@/features/review/config/booking-id-search-schema.ts';

export const Route = createFileRoute('/feedback/')({
  validateSearch: bookingIdSearchSchema,
  component: SubmitFeedback,
});
